// extracted by mini-css-extract-plugin
export default {"container":"PackageForm_container__AVWA4","buttonCancel":"PackageForm_buttonCancel__HTsr1"};